import * as React from 'react';

/**
 * WYSIWYG
 */
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState } from 'draft-js';
import { stateToMarkdown } from 'draft-js-export-markdown';
import { stateFromMarkdown } from 'draft-js-import-markdown';
import { isEqual } from 'lodash';

import './react-draft-wysiwyg.css';
import { TooltipLabel } from '../TooltipLabel/';

export class RichTextEditor extends React.Component<any, any> {
  constructor(props) {
    super(props);
    const defaultContent = props.defaultText;
    const newState = EditorState.createWithContent(stateFromMarkdown(defaultContent));
    const newValue = stateToMarkdown(newState.getCurrentContent());
    this.state = {
      editorState: newState,
      value: newValue
    };
    props.onChange(this.state.value);
  }

  public render() {
    const { ariaLabel, label } = this.props;
    const { editorState } = this.state;

    return (
      <React.Fragment>
        <TooltipLabel ariaLabel={ariaLabel} required={false} label={label} />
        <Editor
          editorState={editorState}
          toolbar={{
            options: [
              'inline',
              'blockType',
              'list',
              'link',
              'remove',
              'history'
            ],
            inline: {
              options: ['bold', 'italic']
            },
            blockType: {
              options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote'],
            },
            link: {
              defaultTargetOption: '_blank'
            }
          }}
          onEditorStateChange={this.onEditorStateChange}
        />
      </React.Fragment>
    );
  }

  public componentDidUpdate(prevProps, prevState) {
    if (!isEqual(this.props.value, prevProps.value) && this.props.value) {
      const editorState = this.initEditorState();

      this.setState({
        editorState
      });
    }

    if (!isEqual(this.state.value, prevState.value)) {
      this.props.onChange(this.state.value);
    }
  }

  private initEditorState() {
    const { value } = this.props;
    const contentState = value
      ? stateFromMarkdown(value)
      : ContentState.createFromText('');

    return EditorState.createWithContent(contentState);
  }

  private onEditorStateChange = (editorState: EditorState) => {
    const newValue = stateToMarkdown(editorState.getCurrentContent());

    this.setState({
      editorState,
      value: newValue
    });
  };
}

export default RichTextEditor;
